import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { useMotivo } from './hooks/useMotivo';
import { useCitaNueva } from './hooks/useCitaNueva';
import { useDatosGenerales } from './hooks/useDatosGenerales';

import { useForm, useFormValidation } from '../../../hooks';

import { PrimaryButton, LightButton, DateInput, TimeInput, NumberInput, TextAreaInput, PacienteInput, TextInput, EmailInput, TelInput, Forbidden, ReactSelectSingleKeyInputModal, ReactSelectSingleInputModal } from '../../../components';

import { eliminarUndefined } from '../../../helpers/eliminarUndefined';

import styles from '../Modals.module.css';

export const CrearCitaAgendaModal = ({ data, hide }) => {

    const { permisos } = useSelector(state => state.auth);

    const [inactivoFlag, setInactivoFlag] = useState(false);
    const [horarioFlag, setHorarioFlag] = useState(false);
    const [empalmadaFlag, setEmpalmadaFlag] = useState(false);
    const [asociadoFlag, setAsociadoFlag] = useState(false);

    const [generoOptions, setGeneroOptions] = useState(['Masculino', 'Femenino']);

    const [nuevoPaciente, setNuevoPaciente] = useState(false);

    const activeInactivoFlag = () => {
        setInactivoFlag(true);
    }

    const activeHorarioFlag = () => {
        setHorarioFlag(true);
    }

    const activeEmpalmadaFlag = () => {
        setEmpalmadaFlag(true);
    }

    const activeAsociadoFlag = () => {
        setAsociadoFlag(true);
    }

    const { datosGeneralesQuery: { isLoading: isLoadingDatosGenerales, isError: isErrorDatosGenerales, data: configuracionDatosGenerales } } = useDatosGenerales();

    const { createCitaMutation: { mutate: createCita } } = useCitaNueva();

    const { motivoQuery: { isLoading, isError, data: motivos } } = useMotivo();

    const { paciente, fecha, hora, motivo, comentario, nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, email, celular, onInputChange, onMultipleInputChange, onResetForm } = useForm({ paciente: '', fecha: (typeof data !== 'undefined' && typeof data.fecha !== 'undefined') ? data.fecha : '', hora: (typeof data !== 'undefined' && typeof data.hora !== 'undefined') ? data.hora : '', motivo: '', comentario: '', nombre: '', apellidoPaterno: '', apellidoMaterno: '', fechaNacimiento: '', genero: '', email: '', celular: '' });

    const { duracion, onInputChange: onInputChangeSecond, onResetForm: onResetFormSecond } = useForm({ duracion: (typeof data !== 'undefined' && typeof data.duracion !== 'undefined') ? ((parseInt(data.duracion) !== 1440) ? parseInt(data.duracion) : 60) : 0 });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, setMultipleFormFieldValidation, onResetValidation } = useFormValidation([{field: 'paciente', default: false}, {field: 'fecha', default: (typeof data !== 'undefined' && typeof data.fecha !== 'undefined') ? true : false}, {field: 'hora', default: (typeof data !== 'undefined' && typeof data.hora !== 'undefined') ? true : false}, {field: 'motivo', default: false}, {field: 'comentario', default: true}, {field: 'nombre', default: true}, {field: 'apellidoPaterno', default: true}, {field: 'apellidoMaterno', default: true}, {field: 'fechaNacimiento', default: true}, {field: 'genero', default: true}, {field: 'email', default: true}, {field: 'celular', default: true}]);

    const { isFormValid: isFormValidSecond, formValidationStatus: formValidationStatusSecond, formFields: formFieldsSecond, startFormValidation: startFormValidationSecond, setFormFieldValidation: setFormFieldValidationSecond, onResetValidation: onResetValidationSecond } = useFormValidation([{field: 'duracion', default: (typeof data !== 'undefined' && typeof data.duracion !== 'undefined') ? true : false}]);

    const handleMotivoChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);

        onInputChangeSecond({ target: { name: 'duracion', value: motivos.find(motivo => String(motivo._id) === String(e.target.value)).duracion } });
    }

    const handleInputChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);
    }

    const handleInputChangeSecond = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChangeSecond(e);
    }

    const handleSuccessSubmit = () => {
        onResetForm();
        onResetValidation();
        onResetFormSecond();
        onResetValidationSecond();
    }

    useEffect(() => {
        let opcionesGenero = ['Masculino', 'Femenino'];
        if(typeof configuracionDatosGenerales !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion !== 'undefined' && typeof configuracionDatosGenerales.fichaIdentificacion.genero !== 'undefined'){
          if(typeof configuracionDatosGenerales.fichaIdentificacion.generoOtro !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.generoOtro){
            opcionesGenero.push('Otro');
          }
          if(typeof configuracionDatosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo !== 'undefined' && configuracionDatosGenerales.fichaIdentificacion.generoPrefieroNoDecirlo){
            opcionesGenero.push('Prefiero no decirlo');
          }
        }
        setGeneroOptions(opcionesGenero);
    }, [configuracionDatosGenerales])

    function separarNombreCompleto(nombreCompleto) {
        if (!nombreCompleto || typeof nombreCompleto !== 'string') return null;

        const partes = nombreCompleto.trim().split(/\s+/);

        if (partes.length < 3) {
            // No se puede separar bien
            return {
            nombres: partes.slice(0, 1).join(' ') || '',
            apellidoPaterno: partes[1] || '',
            apellidoMaterno: ''
            };
        }

        const apellidoMaterno = partes.pop();
        const apellidoPaterno = partes.pop();
        const nombres = partes.join(' ');

        return {
            nombres,
            apellidoPaterno,
            apellidoMaterno
        };
    }

    useEffect(() => {
        if(paciente.includes('||created||')){
            setNuevoPaciente(true);
            let pacienteAux = separarNombreCompleto(paciente.replace('||created||', ''));
            onMultipleInputChange([{ target: { name: 'nombre', value: pacienteAux.nombres } }, { target: { name: 'apellidoPaterno', value: pacienteAux.apellidoPaterno } }, { target: { name: 'apellidoMaterno', value: pacienteAux.apellidoMaterno } }, { target: { name: 'fechaNacimiento', value: '' } }, { target: { name: 'genero', value: '' } }, { target: { name: 'email', value: '' } }, { target: { name: 'celular', value: '' } }]);
            setMultipleFormFieldValidation([{ name: 'nombre', value: true }, { name: 'apellidoPaterno', value: (pacienteAux.apellidoPaterno !== '') }, { name: 'apellidoMaterno', value: true }, { name: 'fechaNacimiento', value: false }, { name: 'genero', value: false }, { name: 'email', value: false }, { name: 'celular', value: false }]);
        }else{
            setNuevoPaciente(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paciente])

    const onSubmit = async ( event ) => {
        event.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid && formValidationStatusSecond === 'checked' && isFormValidSecond != null && isFormValidSecond){
            createCita({ data: eliminarUndefined({ paciente: (!paciente.includes('||created||')) ? paciente : '||created||', nombre, apellidoPaterno, apellidoMaterno, fechaNacimiento, genero, email, celular, fecha, hora, motivo, duracion, comentario, inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag, asociadoConfirmacion: asociadoFlag }, { paciente: undefined, comentario: undefined }), onSuccess: handleSuccessSubmit, onComplete: hide, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag, onAsociado: activeAsociadoFlag});
        }else{
            startFormValidation();
            startFormValidationSecond();
        }

    }

    return (permisos.citaCreate) ? (
        <>
        {(isLoading || isLoadingDatosGenerales)
            ? <>Cargando...</>
            : <>
                {(isError || isErrorDatosGenerales)
                    ? <>Error</>
                    : <>
                        <div>
                            <form onSubmit={ onSubmit }>
                                <div className="row mb-3">
                                    <div className="col">
                                        <div className={styles.modalHeader}>Cita nueva</div>
                                    </div>
                                </div>
                                {(!nuevoPaciente) &&
                                <div className="row">
                                    <div className="col">
                                        <PacienteInput
                                            formFieldStatus={ formFields['paciente'].status }
                                            isClearable={true}
                                            label="Paciente"
                                            name="paciente"
                                            onChange={ handleInputChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={paciente}
                                        />
                                    </div>
                                </div>
                                }
                                {(nuevoPaciente) &&
                                <div className="row">
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                            formFieldStatus={ formFields['nombre'].status }
                                            label="Nombre(s)"
                                            name="nombre"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ nombre }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                            formFieldStatus={ formFields['apellidoPaterno'].status }
                                            label="Apellido paterno"
                                            name="apellidoPaterno"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ apellidoPaterno }
                                        />
                                    </div>
                                    {(configuracionDatosGenerales.fichaIdentificacion.apellidoMaterno) &&
                                    <div className="col-md-12 col-lg-4">
                                        <TextInput
                                            formFieldStatus={ formFields['apellidoMaterno'].status }
                                            label="Apellido materno"
                                            name="apellidoMaterno"
                                            onChange={ onInputChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ apellidoMaterno }
                                        />
                                    </div>
                                    }
                                    <div className="col-md-12 col-lg-4">
                                        <DateInput
                                            formFieldStatus={ formFields['fechaNacimiento'].status }
                                            label="Fecha de nacimiento"
                                            name="fechaNacimiento"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ fechaNacimiento }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <ReactSelectSingleInputModal
                                            formFieldStatus={ formFields['genero'].status }
                                            label="Género"
                                            name="genero"
                                            onChange={ onInputChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={genero}
                                            values={generoOptions}
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <EmailInput
                                            formFieldStatus={ formFields['email'].status }
                                            label="Correo electrónico"
                                            name="email"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ email }
                                        />
                                    </div>
                                    <div className="col-md-12 col-lg-4">
                                        <TelInput
                                            formFieldStatus={ formFields['celular'].status }
                                            label="Teléfono móvil"
                                            name="celular"
                                            onChange={ onInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ celular }
                                        />
                                    </div>
                                </div>
                                }
                                <div className="row">
                                    <div className="col-6">
                                        <DateInput
                                            formFieldStatus={ formFields['fecha'].status }
                                            label={(nuevoPaciente) ? "Fecha de cita" : "Fecha"}
                                            name="fecha"
                                            onChange={ handleInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ fecha }
                                        />
                                    </div>
                                    <div className="col-6">
                                        <TimeInput
                                            formFieldStatus={ formFields['hora'].status }
                                            label={(nuevoPaciente) ? "Hora de cita" : "Hora"}
                                            name="hora"
                                            onChange={ handleInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ hora }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <ReactSelectSingleKeyInputModal
                                            formFieldStatus={ formFields['motivo'].status }
                                            label="Motivo"
                                            name="motivo"
                                            onChange={ handleMotivoChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={motivo}
                                            values={motivos.map(motivo => ({ value: motivo._id, label: motivo.nombre }))}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <NumberInput
                                            formFieldStatus={ formFieldsSecond['duracion'].status }
                                            label="Duración (min)"
                                            name="duracion"
                                            onChange={ handleInputChangeSecond }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidationSecond }
                                            value={ duracion }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <TextAreaInput
                                            formFieldStatus={ formFields['comentario'].status }
                                            label="Comentario"
                                            name="comentario"
                                            onChange={ handleInputChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ comentario }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        {(inactivoFlag) && <p className={styles.helperErrorText}>La fecha seleccionada esta marcada como día inactivo en la configuración del consultorio. ¿Deseas continuar igualmente?</p>}
                                        {(horarioFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado esta fuera del horario configurado para el consultorio. ¿Deseas continuar igualmente?</p>}
                                        {(empalmadaFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado se empalma con otra cita previamente agendada. ¿Deseas continuar igualmente?</p>}
                                        {(asociadoFlag) && <p className={styles.helperErrorText}>El email proporcionado ya se encuentra registrado con otro usuario. ¿Deseas asociarlo?</p>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-6">
                                        <LightButton
                                            block={true}
                                            icon="X"
                                            marginTop={false}
                                            onClick={ hide }
                                            text="Cancelar"
                                            type="button"
                                        />
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-6'>
                                        <PrimaryButton
                                            block={true}
                                            disabled={formValidationStatus === 'checking'}
                                            icon="Check"
                                            marginTop={false}
                                            text={(inactivoFlag || horarioFlag || empalmadaFlag || asociadoFlag) ? "Confirmar" : "Crear"}
                                            type="submit"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </>
                }
            </>
        }
        </>
    ) : <Forbidden />
}

CrearCitaAgendaModal.propTypes = {
  data: PropTypes.object,
  hide: PropTypes.func.isRequired,
}